// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__1qh_N","large":"styles_large__2ZD4B"};